import React from "react";
import { Link } from "react-router-dom";
import "./FamilyProductGroup.scss";
import CustomTooltip from "../../../common/components/CustomTooltip";

const FamilyProductGroup = ({
  familyProduct,
  isOpen,
  familyProductsFilters,
  aggregatedFamilyProducts,
  user,
}) => {
  return (
    isOpen && (
      <ul className="list-group list-group-flush">
        {familyProduct.children.map(
          (familyProductChild) =>
            familyProductsFilters?.includes(familyProductChild._id) &&
            aggregatedFamilyProducts.find(
              (x) => x.id === familyProductChild._id,
            )?.isVisible && (
              <li
                key={familyProductChild._id}
                style={{
                  order: familyProductsFilters.findIndex(
                    (x) => x === familyProductChild._id,
                  ),
                }}
                className="list-group-item list-group-item-action"
              >
                <div className="d-flex flex-row w-100">
                  <p className="w-75 m-0">
                    {familyProductChild.shortLabel || familyProductChild.label}
                  </p>

                  {/* fdesMeres */}

                  <div className="button-container d-flex justify-content-end ml-1 w-25">
                    {familyProductChild?.documentation?.fdesMeres?.elements
                      ?.length > 1 ? (
                      //if multiple fdesMeres

                      <div className="dropdown fdes">
                        <a
                          type="button"
                          href="!#"
                          id={familyProductChild._id}
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div
                            className="button-container onHover"
                            data-tooltip-content={"Voir les FDES mères"}
                            data-tooltip-id={`fdesMeres${familyProductChild._id}`}
                          >
                            <i className="feather icon-file-text m-0" />
                            <i
                              className="feather icon-chevron-down m-0"
                              style={{ fontSize: "1rem" }}
                            />
                          </div>
                        </a>
                        <CustomTooltip
                          id={`fdesMeres${familyProductChild._id}`}
                          place="top"
                        />
                        <div
                          className="dropdown-menu m-0"
                          aria-labelledby={familyProductChild._id}
                        >
                          {familyProductChild.documentation.fdesMeres.elements
                            .slice()
                            .sort((a, b) => a.order - b.order)
                            .map(
                              (x, i) =>
                                x && (
                                  <div key={i + x.file} className="text-nowrap">
                                    <a
                                      href={x.file}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="p-0"
                                    >
                                      <p className="px-1">{x.title}</p>
                                    </a>
                                  </div>
                                ),
                            )}

                          {familyProductChild.children?.length > 0 &&
                            familyProductsFilters.map((familyProductId) =>
                              familyProductChild?.children.map((x) =>
                                //eslint-disable-line
                                x._id === familyProductId ? (
                                  x.documentation?.fdesMeres?.elements
                                    ?.slice()
                                    .sort((a, b) => a.order - b.order)
                                    .map((x, i) => (
                                      <div
                                        key={i + "element"}
                                        className="text-nowrap"
                                      >
                                        <a
                                          href={x.file}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="p-0"
                                        >
                                          <p className="px-1">{x.title}</p>
                                        </a>
                                      </div>
                                    ))
                                ) : (
                                  <></>
                                ),
                              ),
                            )}
                        </div>
                      </div>
                    ) : (
                      //if unique fdesMere

                      <div className="fdes">
                        {familyProductChild?.documentation?.fdesMeres
                          ?.elements[0]?.file && (
                          <a
                            href={
                              familyProductChild.documentation.fdesMeres
                                .elements[0].file
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i
                              className="feather icon-file-text m-0 onHover"
                              data-tooltip-content={"Voir la FDES mère"}
                              data-tooltip-id={`fdesMeres${familyProductChild._id}`}
                            />
                            <CustomTooltip
                              id={`fdesMeres${familyProductChild._id}`}
                              place="top"
                            />
                          </a>
                        )}
                      </div>
                    )}
                    {/* edit */}
                    {aggregatedFamilyProducts.find(
                      (x) => x.id === familyProductChild._id,
                    )?.isVisible && (
                      <>
                        {user.token && user._id ? (
                          <>
                            {familyProductChild.currentFdes?._id &&
                              familyProductChild._id &&
                              !familyProductChild.maintenance &&
                              familyProductChild.children?.length === 0 &&
                              (aggregatedFamilyProducts.find(
                                (x) => x.id === familyProductChild._id,
                              )?.isAccessible ? (
                                //if is accessible
                                <div className="edit">
                                  <Link
                                    to={`/fdes/${familyProductChild._id}`}
                                    className=""
                                  >
                                    <i
                                      className="feather icon-edit m-0 onHover"
                                      data-tooltip-content={
                                        familyProductChild.content &&
                                        familyProductChild.content
                                          .helpTextLabel &&
                                        familyProductChild.content.helpTextLabel
                                          ? familyProductChild.content
                                              .helpTextLabel
                                          : "Réaliser une FDES"
                                      }
                                      data-tooltip-id={`fdesEdit${familyProductChild._id}`}
                                    />
                                    <CustomTooltip
                                      id={`fdesEdit${familyProductChild._id}`}
                                      place="top"
                                    />
                                  </Link>
                                </div>
                              ) : (
                                //if is not accessible
                                <div className="edit">
                                  <i
                                    className="feather icon-edit m-0"
                                    data-tooltip-content={
                                      familyProductChild.currentFdes?._id
                                        ? "Cette fonctionnalité n’est pas accessible à votre niveau d’utilisation"
                                        : "Cette fonctionnalité n'est pas encore accessible aux utilisateurs"
                                    }
                                    data-tooltip-id={`fdesEdit${familyProductChild._id}`}
                                    disable="true"
                                  />
                                  <CustomTooltip
                                    id={`fdesEdit${familyProductChild._id}`}
                                    place="top"
                                  />
                                </div>
                              ))}
                          </>
                        ) : (
                          <div className="edit">
                            <i
                              className="feather icon-edit m-0 "
                              data-tooltip-content={
                                "Afin de pouvoir utiliser le configurateur, vous devez vous connecter, en vous créant un compte auparavant si nécessaire."
                              }
                              data-tooltip-id={`fdesEdit${familyProductChild._id}`}
                              disable="true"
                            />
                            <CustomTooltip
                              id={`fdesEdit${familyProductChild._id}`}
                              place="top"
                            />
                          </div>
                        )}

                        {/* sub-sub-families */}
                        {user.token && user._id && (
                          <>
                            {familyProductChild.children?.length > 0 &&
                              hasChildrenVisible(
                                familyProductChild,
                                aggregatedFamilyProducts,
                              ) && (
                                <div className="dropdown edit">
                                  {
                                    // eslint-disable-next-line
                                    <a
                                      type="button"
                                      id={familyProductChild._id}
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                      data-tooltip-content={
                                        familyProductChild.content &&
                                        familyProductChild.content
                                          .helpTextLabel &&
                                        familyProductChild.content.helpTextLabel
                                          ? familyProductChild.content
                                              .helpTextLabel
                                          : "Réaliser une FDES"
                                      }
                                      data-tooltip-id={`fdesEdit${familyProductChild._id}`}
                                    >
                                      <div className="button-container onHover">
                                        <i className="feather icon-edit m-0" />
                                        <i
                                          className="feather icon-chevron-down m-0"
                                          style={{ fontSize: "1rem" }}
                                        />
                                      </div>
                                      <CustomTooltip
                                        id={`fdesEdit${familyProductChild._id}`}
                                        place="top"
                                      />
                                    </a>
                                  }
                                  {hasChildrenVisible(
                                    familyProductChild,
                                    aggregatedFamilyProducts,
                                  ) && (
                                    <div
                                      className="dropdown-menu text-nowrap"
                                      aria-labelledby={familyProductChild._id}
                                    >
                                      {familyProductsFilters.map(
                                        (familyProductId) =>
                                          familyProductChild?.children.map(
                                            (x, i) =>
                                              x._id === familyProductId &&
                                              getSubSubFamilyDisplay({
                                                isVisible:
                                                  aggregatedFamilyProducts.find(
                                                    (z) => z.id === x._id,
                                                  )?.isVisible,
                                                isAccessible:
                                                  aggregatedFamilyProducts.find(
                                                    (y) => y.id === x._id,
                                                  )?.isAccessible,
                                                hasModel: x.currentFdes?.active,
                                                index: i,
                                                name: x.name,
                                                productFamily:
                                                  x.currentFdes?.productFamily,
                                              }),
                                          ),
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                          </>
                        )}
                      </>
                    )}
                  </div>

                  {/* if familly under maintenance */}
                  {familyProductChild.currentFdes &&
                    familyProductChild.currentFdes._id &&
                    familyProductChild._id &&
                    familyProductChild.maintenance && (
                      <div className="button-container">
                        <i
                          className="feather icon-alert-triangle danger darken-4"
                          data-tooltip-content="Famille de produit en maintenance."
                          data-tooltip-id={`maintenance${familyProductChild._id}`}
                        />
                        <CustomTooltip
                          id={`maintenance${familyProductChild._id}`}
                          place="right"
                        />
                      </div>
                    )}
                </div>
              </li>
            ),
        )}
      </ul>
    )
  );
};

export default FamilyProductGroup;

const hasChildrenVisible = (familyProductChild, aggregatedFamilyProducts) => {
  return familyProductChild.children?.some((x) =>
    aggregatedFamilyProducts.find((z) => z.id === x._id && z.isVisible),
  );
};

const getSubSubFamilyDisplay = ({
  isVisible,
  isAccessible,
  hasModel,
  index,
  productFamily,
  name,
}) => {
  if (isVisible && isAccessible && hasModel) {
    return (
      <Link key={index + "productFamily"} to={`/fdes/${productFamily}`}>
        <p className="px-1">{name}</p>
      </Link>
    );
  } else {
    return isVisible ? (
      <div key={index + "productFamily"}>
        <p
          className="px-1"
          data-tooltip-content={
            hasModel
              ? "Cette fonctionnalité n’est pas accessible à votre niveau d’utilisation"
              : "Cette fonctionnalité n’est pas encore accessible aux utilisateurs"
          }
          data-tooltip-id={`sub-sub-family-tooltip-${index}`}
        >
          {name}
        </p>
        <CustomTooltip id={`sub-sub-family-tooltip-${index}`} place="top" />
      </div>
    ) : (
      <></>
    );
  }
};
